var afip_config;

(function ($, undefined) {
    'use strict';
    afip_config = {};

    $(".default_pos").on('click',function (e) {
        afip_config.set_default(e);
    });

    afip_config.set_default = function(e){
       $(".default_pos").prop( "checked", false );
       e.currentTarget.checked =true
    };

    $("#logo").on('change',(evt) => {
        const [file] = $("#logo").files
        if (file) {
            $("#logo").src = URL.createObjectURL(file)
        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/afip_config.js